module.exports = __webpack_public_path__ + "static/media/breadcrumb-tail-flat-selected.cc604bd4.svg";